var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPositiveGreenEmoticon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2546 48 48 37.2546 48 24C48 10.7454 37.2546 0 24 0C10.7454 0 0 10.7454 0 24C0 37.2546 10.7454 48 24 48Z",
    fill: "#83BB26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2697 18.3895C14.2697 21.0275 12.1286 23.1686 9.49057 23.1686C6.85253 23.1686 4.71143 21.0275 4.71143 18.3895C4.71143 15.7515 6.85253 13.6104 9.49057 13.6104C12.1286 13.6104 14.2697 15.7484 14.2697 18.3895Z",
    fill: "#1C1C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34985 16.5397C9.34985 17.3157 8.72102 17.9446 7.94495 17.9446C7.16887 17.9446 6.54004 17.3157 6.54004 16.5397C6.54004 15.7636 7.16887 15.1348 7.94495 15.1348C8.72102 15.1348 9.34985 15.7636 9.34985 16.5397Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8897 18.7542C10.8897 19.202 10.5277 19.564 10.0798 19.564C9.63198 19.564 9.27002 19.202 9.27002 18.7542C9.27002 18.3063 9.63198 17.9443 10.0798 17.9443C10.5277 17.9443 10.8897 18.3063 10.8897 18.7542Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2883 18.3895C43.2883 21.0275 41.1502 23.1686 38.5091 23.1686C35.868 23.1686 33.73 21.0275 33.73 18.3895C33.73 15.7515 35.868 13.6104 38.5091 13.6104C41.1502 13.6104 43.2883 15.7484 43.2883 18.3895Z",
    fill: "#1C1C1C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3679 16.5397C38.3679 17.3157 37.7391 17.9446 36.963 17.9446C36.1869 17.9446 35.5581 17.3157 35.5581 16.5397C35.5581 15.7636 36.1869 15.1348 36.963 15.1348C37.7391 15.1348 38.3679 15.7636 38.3679 16.5397Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9077 18.7542C39.9077 19.202 39.5458 19.564 39.0979 19.564C38.65 19.564 38.2881 19.202 38.2881 18.7542C38.2881 18.3063 38.65 17.9443 39.0979 17.9443C39.5458 17.9443 39.9077 18.3063 39.9077 18.7542Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9204 27.2421C12.9204 28.5856 11.4572 29.6746 9.64738 29.6746C7.83756 29.6746 6.37744 28.5856 6.37744 27.2421C6.37744 25.8985 7.84063 24.8096 9.64738 24.8096C11.4541 24.8096 12.9204 25.8985 12.9204 27.2421Z",
    fill: "#FFD525"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6196 27.2421C41.6196 28.5856 40.1533 29.6746 38.3497 29.6746C36.546 29.6746 35.0767 28.5856 35.0767 27.2421C35.0767 25.8985 36.5429 24.8096 38.3497 24.8096C40.1564 24.8096 41.6196 25.8985 41.6196 27.2421Z",
    fill: "#FFD525"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 28.8066C26.5613 28.8066 28.8557 29.8096 30.4079 31.3986C31.2238 30.4691 31.8741 29.3648 32.3067 28.1378C32.8496 26.598 31.9079 24.8955 30.503 24.8955H17.4938C16.0919 24.8955 15.1471 26.598 15.6932 28.1378C16.1257 29.3618 16.776 30.4691 17.5919 31.3986C19.1441 29.8127 21.4386 28.8066 23.9999 28.8066Z",
    fill: "#1C1C1C"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9998 34.3864C26.5151 34.3864 28.7881 33.2392 30.4077 31.3956C28.8556 29.8097 26.5611 28.8066 23.9998 28.8066C21.4384 28.8066 19.1439 29.8097 17.5918 31.3956C19.2114 33.2392 21.4814 34.3864 23.9998 34.3864Z",
    fill: "#FF2180"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositiveGreenEmoticon);
export default __webpack_public_path__ + "static/media/positive-green-emoticon.b57b72a0.svg";
export { ForwardRef as ReactComponent };